<template>
    <div v-loading="loading">
        <h3 style="text-align:center;">{{ $t('reports.priceRangeTitle') }}</h3>
        <div id="chartByPriceRange" style="height:400px;width:400px;margin:auto;">
        </div>
        <el-table v-if="showTable"
            :data="summarizedData"
            stripe
            height="400"
            sum-text="Total"
            class="card-shadow--small"
            v-show="summarizedData &&  summarizedData.length || loading === false"
            :default-sort = "{prop: 'value', order: 'descending'}"
            show-summary
            style="width: 100%">
            <el-table-column
            prop="name"
            :label="$t('reports.priceRangeLabel')"
            sortable
            width="180">
                <template slot-scope="scope">
                    <span>{{ formatRange(scope.row.name) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="value"
                sortable
                :label="$t('common.QtyBt')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="value9L"
                sortable
                :label="$t('common.Qty9L')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value9L) }}</span>
                </template>
            </el-table-column>
        </el-table>
</div>
</template>
<script>

import * as echarts from 'echarts';
import salesAPI from '@/services/API/sales'
import portausUtils from '@/utils/portaus-utils';

export default {
    name: 'SalesByPriceRange',
    props: {
        showTable: {
        type: Boolean,
        default: false
        },
        filters: Object,
        type: {
            type: String,
            default: 'VALUE'
        },
        max: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            loading: true,
            data: [],
        }
    },
    components: {
    },
    watch: {
        type: function (val) {
            this.initChart();
        },
        filters: function (val) {
           this.init();
        }
    },
    methods: {
        formatRange(range) {
            let formatedRangeArray = [];
            let rangeArray = _.split(range, ' - ');
            if (_.size(rangeArray) == 1){
                rangeArray = [_.last(_.split(range, '>= '))];
            }
            _.forEach(rangeArray, element => {
                formatedRangeArray.push(this.formatAmount(element, this.$i18n.locale));
            })
            if (_.size(rangeArray) == 1){
                return `>= ${_.head(formatedRangeArray)}`;
            }
            return _.join(formatedRangeArray, ' - ');
        },
        formatAmount(amount) {
            return portausUtils.formatAmount(amount, this.$i18n.locale);
        },
        formatNumber(amount) {
            return portausUtils.formatNumber(amount, this.$i18n.locale);
        },
        init() {
            this.loading = true;
            if (this.filters.inventoryId == null) return null;
            this.getSalesByPriceRange(this.filters)
                .then((data) => {
                    this.data = data;
                    
                    this.initChart();
                    this.loading = false;
                }).catch((err) => {
                    this.loading = false;
                })
        },
        getSalesByPriceRange (filters) {
            return salesAPI.getSalesByPriceRange(filters);
        },
        initChart () {
            this.chart = echarts.init(document.getElementById('chartByPriceRange'));
            this.chart.setOption({
                title: {
                    show:false,
                    text: "Ventes par tranche de prix",
                    padding:0,
                    left:'center',
                    textAlign:'center'
                },
                tooltip: {
                    show:true,
                    trigger: 'item',
                    appendToBody: true,
                },
                legend: {
                    show:false,
                    orient: 'vertical',
                    left: 'left',
                    selectedMode: false,
                },
                series: [
                    {
                        // name: 'Ventes / Type.',
                        type: 'pie',
                        radius: ['40%', '60%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                        },
                        label: {
                            show: true,
                            overflow: 'break',
                            width: 75,
                        },
                        labelLine: {
                            show: true
                        },
                        data: this.chartData,
                    }
                ]
            });
        }
    },
    computed : {
        chartData () {
            return _.map(this.dataByType, data => ({ value: data.value, name: `${data.name}`, tooltip: { valueFormatter: (value) => value}}))
        },
        dataByType() {
            return this.dataByValue;

        },
        summarizedData () {
            if (this.max >= 0) {
                return _.slice(this.dataByType, 0, this.max);
            } else {
                return this.dataByType;
            }
           
        },
        dataByValue () {
            return _.orderBy(_.map(this.data, d => ({name: _.last(_.split(d.range, '|')), value: Number(d.sum), value9L: Number(d.qty9l) })), ['valueOrder'], ['desc']);
        }
    },
    mounted() {
        this.init();
        
    }
   
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
  